export const APP_NAME = "DEGA-8";